var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "auth-form" }, [
    _c("h2", { staticClass: "auth-form__title text-center" }, [
      _vm._v(_vm._s(_vm.t.h_login))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "auth-form__text auth-form__text_social" }, [
      _vm._v(_vm._s(_vm.t.login_social))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "text-center" }, [
      !_vm.oauthUrls ? _c("div", { staticClass: "loader" }) : _vm._e(),
      _vm._v(" "),
      _vm.oauthUrls
        ? _c("div", { staticClass: "auth-form__social-buttons" }, [
            _vm.oauthUrls.facebook
              ? _c(
                  "a",
                  {
                    staticClass:
                      "btn btn-primary auth-form__social-button auth-form__social-button_facebook",
                    attrs: { href: _vm.oauthUrls.facebook }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: "/img/icons/Social/facebook-icon.png",
                        srcset:
                          "/img/icons/Social/facebook-icon@2x.png" + " 2x",
                        alt: ""
                      }
                    }),
                    _vm._v(" Facebook")
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.oauthUrls.google
              ? _c(
                  "a",
                  {
                    staticClass:
                      "btn btn-primary auth-form__social-button auth-form__social-button_google",
                    attrs: { href: _vm.oauthUrls.google }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: "/img/icons/Social/google-icon.png",
                        srcset: "/img/icons/Social/google-icon@2x.png" + " 2x",
                        alt: ""
                      }
                    }),
                    _vm._v(" Google")
                  ]
                )
              : _vm._e()
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "auth-form__text auth-form__text_email" }, [
      _vm._v(_vm._s(_vm.t.login_email))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "auth-form__form" }, [
      _c(
        "form",
        {
          attrs: { action: _vm.url, method: "post" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.submit($event)
            }
          }
        },
        [
          _c("div", { staticClass: "form-group" }, [
            _c("label", { attrs: { for: "loginform-email" } }, [
              _vm._v(_vm._s(_vm.t.email))
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.formData.email,
                  expression: "formData.email"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                name: "email",
                id: "loginform-email",
                disabled: _vm.loading
              },
              domProps: { value: _vm.formData.email },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.formData, "email", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _vm.formErrors.email
              ? _c("div", { staticClass: "form-text text-danger" }, [
                  _vm._v(_vm._s(_vm.formErrors.email))
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c(
              "a",
              {
                staticClass: "float-right",
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.$emit("recover")
                  }
                }
              },
              [_vm._v(_vm._s(_vm.t.forgot_password))]
            ),
            _vm._v(" "),
            _c("label", { attrs: { for: "loginform-password" } }, [
              _vm._v(_vm._s(_vm.t.password))
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.formData.password,
                  expression: "formData.password"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "password",
                name: "password",
                id: "loginform-password",
                disabled: _vm.loading
              },
              domProps: { value: _vm.formData.password },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.formData, "password", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _vm.formErrors.password
              ? _c("div", { staticClass: "form-text text-danger" }, [
                  _vm._v(_vm._s(_vm.formErrors.password))
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { attrs: { id: "login-recaptcha-container" } }),
          _vm._v(" "),
          _vm.formErrors["g-recaptcha-response"]
            ? _c("div", { staticClass: "form-text text-danger" }, [
                _vm._v(_vm._s(_vm.formErrors["g-recaptcha-response"]))
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "form-group form-group-submit mt-3" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-shadow-primary btn-block",
                attrs: { type: "submit", disabled: _vm.loading }
              },
              [_vm._v(_vm._s(_vm.t.login))]
            )
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("div", { staticClass: "text-center" }, [
      _c("span", { staticClass: "mr-2" }, [
        _vm._v(_vm._s(_vm.t.not_registered))
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          attrs: { href: "#" },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.$emit("register")
            }
          }
        },
        [_vm._v(_vm._s(_vm.t.register))]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }